import React from "react";
import { DARK_GRAY, TRANSPARENT, RED } from "../../theme";
import { NavBar } from "./Nav.styles";
import { SITE_URL } from "../.././constants";

const Nav = () => {
  const links = [
    {
      to: `${SITE_URL}/about`,
      title: "About us",
      useFullInternalLink: true,
    },
    {
      to: `${SITE_URL}/articles`,
      title: "Articles",
      useFullInternalLink: true,
    },
  ];

  return (
    <>
      <NavBar
        logo="https://storage.googleapis.com/cookingandcocktails-assets/Logo_Transparent%402x.png"
        mobileLogo="https://storage.googleapis.com/cookingandcocktails-assets/favicon_2.png"
        links={links}
        menuItemColor={DARK_GRAY}
        headerColor={TRANSPARENT}
        menuColor={RED}
        menuIconColor={DARK_GRAY}
        font="Avenir Next Condensed"
      />
    </>
  );
};

export default Nav;
